var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDollarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.625 13.2666H11.1667C11.7083 13.2666 12.1583 12.7833 12.1583 12.1999C12.1583 11.4749 11.9 11.3333 11.475 11.1833L10.6333 10.8916V13.2666H10.625Z",
    fill: "#0F55DC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.97441 1.58302C5.3744 1.59969 1.6494 5.34136 1.66607 9.94135C1.68274 14.5414 5.4244 18.2664 10.0244 18.2497C14.6244 18.233 18.3494 14.4914 18.3327 9.89135C18.3161 5.29135 14.5744 1.57469 9.97441 1.58302ZM11.8827 9.99969C12.5327 10.2247 13.4077 10.708 13.4077 12.1997C13.4077 13.483 12.3994 14.5164 11.1661 14.5164H10.6244V14.9997C10.6244 15.3414 10.3411 15.6247 9.9994 15.6247C9.65774 15.6247 9.3744 15.3414 9.3744 14.9997V14.5164H9.07441C7.70774 14.5164 6.5994 13.3664 6.5994 11.9497C6.5994 11.608 6.88274 11.3247 7.2244 11.3247C7.56607 11.3247 7.8494 11.608 7.8494 11.9497C7.8494 12.6747 8.39941 13.2664 9.07441 13.2664H9.3744V10.4497L8.11607 9.99969C7.46607 9.77469 6.59107 9.29135 6.59107 7.79969C6.59107 6.51635 7.59941 5.48302 8.83274 5.48302H9.3744V4.99969C9.3744 4.65802 9.65774 4.37469 9.9994 4.37469C10.3411 4.37469 10.6244 4.65802 10.6244 4.99969V5.48302H10.9244C12.2911 5.48302 13.3994 6.63302 13.3994 8.04969C13.3994 8.39135 13.1161 8.67469 12.7744 8.67469C12.4327 8.67469 12.1494 8.39135 12.1494 8.04969C12.1494 7.32469 11.5994 6.73302 10.9244 6.73302H10.6244V9.54969L11.8827 9.99969Z",
    fill: "#0F55DC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.84961 7.8084C7.84961 8.5334 8.10794 8.67507 8.53294 8.82507L9.37461 9.11673V6.7334H8.83294C8.29128 6.7334 7.84961 7.21673 7.84961 7.8084Z",
    fill: "#0F55DC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollarIcon);
export default __webpack_public_path__ + "static/media/dollar-icon.3d098cf128e04891b2b8646e700e9789.svg";
export { ForwardRef as ReactComponent };